import React from "react";

const Buttons = ({ expanded, ...props }) =>
    <button onClick={props.cancelWR} type="button" className="btn btn-dark me-1">
        Cancel
    </button>

export default Buttons